import { PasswordLinkSentPage } from '@/pages/password-link-sent';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/password-link-sent')({
	component: PasswordLinkSentPage,
});
